import { CSSProperties } from 'react';

// Generic reader for a CSS custom property on <body> — not decile-specific despite the file name;
// reused by other tools (Matrix, Hedge Plans) so a color scheme swap only means editing index.css.
export function readCssColorVariable(variableName: string): string {
  return getComputedStyle(document.body).getPropertyValue(variableName).trim();
}

export function readDecileColor(percentile: number): string {
  return readCssColorVariable(`--decile-${percentile}`) || readCssColorVariable('--decile-fallback');
}

export function getDecileTextColor(percentile: number): string {
  return percentile <= 20 || percentile >= 70
    ? readCssColorVariable('--contrast-text-light')
    : readCssColorVariable('--contrast-text-dark');
}

const chartOpacities = ['44', '55', '77', '99', 'FF', 'FF', '99', '77', '55', '44'];

export function buildDecileMatrixPalette() {
  return Array.from({ length: 10 }, (_, index) => {
    const percentile = 90 - index * 10;
    return {
      color: readDecileColor(percentile),
      chartOpacity: chartOpacities[index],
      textColor: readCssColorVariable('--contrast-text-dark'),
      tableTextColor: getDecileTextColor(percentile),
    };
  });
}

export const decileMatrixStyles: Record<string, CSSProperties> = {
  container: { minWidth: '260px', padding: '12px', display: 'flex', flexDirection: 'column' },
  heading: { margin: '0 0 8px 0', fontSize: '15px', fontWeight: 700, textAlign: 'center', color: 'var(--font-color)' },
  table: { borderCollapse: 'collapse', width: '100%', flex: 1, fontSize: 'var(--ag-font-size, 13px)', fontFamily: 'var(--font-family)' },
  headerCell: { padding: '7px 12px', fontWeight: 700, whiteSpace: 'nowrap', border: '1px solid var(--box-border-color)', color: 'var(--font-color)' },
  labelCell: { padding: '6px 12px', fontWeight: 500, whiteSpace: 'nowrap', border: '1px solid var(--box-border-color)' },
  valueCell: { padding: '6px 12px', textAlign: 'right', whiteSpace: 'nowrap', border: '1px solid var(--box-border-color)', color: 'var(--font-color)' },
};